import { EVALUATE_FILTERS, FEEDBACK, FLAG_EVALUATIONS, FEEDBACK_CONVERSATION } from "../constants/url";
import httpBase, { handleApiExceptions } from "../utils/http.utils";

export const fetchFeedbackConversationAPI = ({
  evaluationId,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const url = FEEDBACK_CONVERSATION.replace("{evaluation_id}", evaluationId);
      const response = await httpBase().get(url);
      const conversationList = Array.isArray(response?.data?.data)
        ? [...response.data.data].reverse()
        : [];

      successCallback({
        ...(response?.data || {}),
        data: conversationList,
      });
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const getAllFiltersApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(EVALUATE_FILTERS);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const fetchFeedbackAPI = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(FEEDBACK, params);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const flagTableRowApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  console.log("DATA -> ", data);
  return async (dispatch) => {
    try {
      const response = await httpBase().post(FLAG_EVALUATIONS, data);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};
